/* ═══════════════════════════════════════════════════
   ARC Theme — arc-theme.js  v1.0.0
   No framework. No dependencies.
   ═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  // ── AJAX add-to-cart ────────────────────────────
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var addBtn = document.getElementById('AddToCart');
      var origText = addBtn ? addBtn.textContent : 'Add to Cart';
      if (addBtn) { addBtn.textContent = 'Adding…'; addBtn.disabled = true; }

      fetch(window.Shopify ? '/cart/add.js' : '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(productForm)).toString()
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-link').forEach(function (el) {
            el.textContent = 'CART ' + cart.item_count;
          });
          if (addBtn) { addBtn.textContent = 'Added!'; }
          setTimeout(function () {
            if (addBtn) { addBtn.textContent = origText; addBtn.disabled = false; }
          }, 1600);
        })
        .catch(function (err) {
          console.error('ARC: cart error', err);
          if (addBtn) { addBtn.textContent = origText; addBtn.disabled = false; }
        });
    });
  }

})();
